<template>
  <section>
    <div
      class="relative flex flex-col w-full h-full min-w-0 break-words bg-white border-0 md:shadow-lg md:rounded-3xl md:h-auto"
    >
      <div class="px-6 pt-10 mb-0 rounded-t">
        <div class="text-center">
          <img
            class="w-24 mx-auto text-xl text-gray-600 md:w-40"
            :src="require('@/assets/icons/logo.svg')"
            alt="FaceStudio"
          >
        </div>
      </div>
      <div class="flex-auto px-4 py-10 lg:px-10">
        <div class="mb-5 text-xl text-center text-gray-600 uppercase">
          {{ "CardTitle_Register" | i18n }}
          <p class="text-base normal-case">
            {{ "CardSubtitle_Register" | i18n }}
          </p>
        </div>

        <form
          novalidate
          @submit.prevent="signUp"
        >
          <div class="relative z-0 w-full mb-5">
            <input
              v-model.trim="name"
              type="text"
              name="name"
              placeholder=" "
              class="block w-full px-0 mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-black"
              :class="$v.name.$error ? 'border-red-600' : 'border-gray-200'"
            >
            <label
              for="name"
              class="absolute duration-300 top-3 -z-1 origin-0"
              :class="$v.name.$error ? 'text-red-600' : 'text-gray-500'"
            >
              {{ "InputLabel_EnterName" | i18n }}
            </label>
            <span
              v-if="$v.name.$dirty && !$v.name.required"
              class="text-sm text-red-600"
            >
              {{ "InputError_EmptyName" | i18n }}
            </span>
          </div>

          <div class="relative z-0 w-full mb-5">
            <input
              v-model.trim="email"
              type="email"
              name="email"
              placeholder=" "
              class="block w-full px-0 mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-black"
              :class="$v.email.$error ? 'border-red-600' : 'border-gray-200'"
            >
            <label
              for="email"
              class="absolute duration-300 top-3 -z-1 origin-0"
              :class="$v.email.$error ? 'text-red-600' : 'text-gray-500'"
            >
              {{ "InputLabel_EnterEmail" | i18n }}
            </label>
            <span
              v-if="$v.email.$dirty && !$v.email.required"
              class="text-sm text-red-600"
            >
              {{ "InputError_EmptyEmail" | i18n }}
            </span>
            <span
              v-if="$v.email.$dirty && !$v.email.email"
              class="text-sm text-red-600"
            >
              {{ "InputError_NotEmail" | i18n }}
            </span>
          </div>

          <div class="relative z-0 w-full mb-5">
            <input
              v-model.trim="password"
              type="password"
              name="password"
              placeholder=" "
              class="block w-full px-0 mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-black"
              :class="$v.password.$error ? 'border-red-600' : 'border-gray-200'"
            >
            <label
              for="password"
              class="absolute duration-300 top-3 -z-1 origin-0"
              :class="$v.password.$error ? 'text-red-600' : 'text-gray-500'"
            >
              {{ "InputLabel_EnterPassword" | i18n }}
            </label>
            <span
              v-if="$v.password.$dirty && !$v.password.required"
              class="text-sm text-red-600"
            >
              {{ "InputError_EmptyPassword" | i18n }}
            </span>
            <span
              v-else-if="$v.password.$dirty && !$v.password.minLength"
              class="text-sm text-red-600"
            >
              {{ "InputError_PasswordLength" | i18n }}
              {{ $v.password.$params.minLength.min }}
              {{ "InputError_PasswordSymbols" | i18n }}
            </span>
          </div>

          <div class="my-12 space-y-2">
            <p>
              {{ "Question_ExistingUser" | i18n }}
              <router-link
                to="/login"
                class="underline"
              >
                {{ "Link_Login" | i18n }}
              </router-link>
            </p>
          </div>

          <div>
            <button
              type="submit"
              class="w-full px-6 py-3 mb-1 mr-1 text-lg text-white transition-all duration-150 ease-linear rounded-lg shadow outline-none bg-fs-500 hover:bg-fs-600 hover:shadow-lg focus:outline-none"
            >
              {{ "Button_Next" | i18n }}
            </button>
            <span class="text-xs font-light text-gray-500">
              {{ "ToSAgreement" | i18n }}
              <a
                href="https://docs.google.com/document/d/e/2PACX-1vRsxMh8Fk7CEAGOSo3q9dl6GcssgReS82XjJ5dP6UGkWtADqVyF5NDibtHr_G3lh7xlKd-g9f0Xxh9x/pub"
                target="_blank"
                class="text-fs-500"
              >
                {{ "ToS" | i18n }}
              </a>
            </span>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { email, required, minLength } from "vuelidate/lib/validators";

export default {
  name: "Register",

  data: () => ({
    name: "",
    email: "",
    password: ""
  }),

  validations: {
    email: { email, required },
    password: { required, minLength: minLength(6) },
    name: { required }
  },

  methods: {
    async signUp() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      const { name, email, password } = this;
      try {
        await this.$store.dispatch("register", { name, email, password });
      } catch (error) {
        this.$logger.error(error);
      }
    }
  }
};
</script>
